import { NavigationItemsLoaderService } from './navigation-items-loader-service.js';
import { MxNavigationItemConfigurationActionsService } from './navigation-item-configuration-actions-service.js';
import { mxShellNavItemDirective } from './components/mx-shell-nav-item/mx-shell-nav-item';
import { mxShellNavigationPanelComponent } from './components/mx-shell-navigation-panel/mx-shell-navigation-panel';

import { NavigationManager } from './mx-shell-nav-manager';
import { MxNavigationProviderService } from './mx-navigation-provider-service';
import { MxNavigationService } from './mx-navigation-service';
import { mxShellToolbarNavigationPopupItemComponent } from './components/mx-shell-toolbar-navigation--popup-item/mx-shell-toolbar-navigation--popup-item';
import { mxShellToolbarNavigationPopupComponent } from './components/mx-shell-toolbar-navigation--popup/mx-shell-toolbar-navigation--popup';
import { mxShellToolbarNavigationComponent } from './components/mx-shell-toolbar-navigation/mx-shell-toolbar-navigation';
import { MxToolbarNavigationService } from './mx-shell-toolbar-navigation-service';
import { NavigationItem } from './model/navigation-item';

export const mxNavigationModule = angular
	.module('mx.sb.Navigation', [])
	.directive('mxShellNavItem', mxShellNavItemDirective)
	.component('mxShellNavigationPanel', mxShellNavigationPanelComponent)
	.component('mxShellToolbarNavigationPopupItem', mxShellToolbarNavigationPopupItemComponent)
	.component('mxShellToolbarNavigationPopup', mxShellToolbarNavigationPopupComponent)
	.component('mxShellToolbarNavigation', mxShellToolbarNavigationComponent)
	.service('mx.shell.NavigationItemsLoaderService', NavigationItemsLoaderService)
	.service('mx.shell.NavigationItemConfigurationActionsService', MxNavigationItemConfigurationActionsService)
	.service('mx.shell.NavigationManager', NavigationManager)
	.service('mx.shell.NavigationProviderService', MxNavigationProviderService)
	.service('mx.shell.NavigationService', MxNavigationService)
	.service('mx.shell.ToolbarNavigationService', MxToolbarNavigationService);

window.mx = window.mx || {};
window.mx.shell = window.mx.shell || {};
window.mx.shell.NavigationItem = NavigationItem;
